import React, { useEffect, useState } from "react";

// import "./availabilty.css";
import Button from "../../Components/UIComponents/Button";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";

const AvailabiltyDrawer = ({
  onHide,
  iconShow,
  setShowBankInfoModal,
  data,
  AccountId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  // Initial state with days of the week
  const initialState = {
    Mo: [{ id: 1, startTime: "", endTime: "" }],
    Tu: [{ id: 1, startTime: "", endTime: "" }],
    We: [{ id: 1, startTime: "", endTime: "" }],
    Th: [{ id: 1, startTime: "", endTime: "" }],
    Fr: [{ id: 1, startTime: "", endTime: "" }],
    Sa: [{ id: 1, startTime: "", endTime: "" }],
    Su: [{ id: 1, startTime: "", endTime: "" }],
  };

  const [availability, setAvailability] = useState(data);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const handleAddInput = (day) => {
    if (availability[day].length < 2) {
      setAvailability({
        ...availability,
        [day]: [
          ...availability[day],
          { id: availability[day].length + 1, startTime: "", endTime: "" },
        ],
      });
    } else {
      alert("You can only add up to 2 availability slots per day.");
    }
  };

  const handleRemoveInput = (day, id) => {
    setAvailability({
      ...availability,
      [day]: availability[day].filter((slot) => slot.id !== id),
    });
  };

  const handleInputChange = (day, id, field, value) => {
    const updatedDay = availability[day].map((slot) =>
      slot.id === id ? { ...slot, [field]: value } : slot
    );
    setAvailability({ ...availability, [day]: updatedDay });
  };

  const navigate = useNavigate();

  const availabiltysetHandler = async () => {
    let isTimeSelected = false;
    // Check if any time slot is selected
    Object.keys(availability).forEach((day) => {
      availability[day].forEach((slot) => {
        if (slot.startTime && slot.endTime) {
          isTimeSelected = true;
        }
      });
    });

    try {
      // If a time slot is selected, set availabitySet and close the drawer
      if (isTimeSelected) {
        setIsLoading(true);
        const availabiltyRes = await servicePost(
          "adminauth/contractorAvailability",
          {
            id: AccountId,
            availability: availability,
          },
          notification,
          authToken
        );

        if (availabiltyRes.message == "SUCCESS") {
          setIsLoading(false);
          onHide();
          setShowBankInfoModal(true);
        }
      } else {
        alert("Please select a time slot before saving.");
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  return (
    <div className="availability-drawer-main-wrapper">
      <div className="service-drawer-main-wrap">
        <div className="service-drawer-header">
          <div className="bank-detail-head-contant">
            <h3>Select Days& Timing </h3>
            <p> Mark your Availability working days and hours </p>
          </div>
          {iconShow ? (
            <div className="drawer-close-icon-wrap">
              <img
                onClick={() => onHide()}
                src="./images/icons/close-icon.svg"
                alt="icon"
              />
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="availability-main-wrapper">
          {availability &&
            Object.keys(availability).map((day) => (
              <div key={day} className="availability-main-wrap">
                <div className="availability-day-wrap">
                  <h3>{day?.slice(0, 1)}</h3>
                </div>
                <div className="availability-input-repeat">
                  {availability[day].map((slot, index) => (
                    <div key={slot.id} className="availability-input-wrapper">
                      <div className="availability-input-left-wrap">
                        <input
                          type="time"
                          value={slot.startTime}
                          onChange={(e) =>
                            handleInputChange(
                              day,
                              slot.id,
                              "startTime",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <p>to</p>
                      <div className="availability-input-left-wrap">
                        <input
                          type="time"
                          value={slot.endTime}
                          onChange={(e) =>
                            handleInputChange(
                              day,
                              slot.id,
                              "endTime",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      {index === 0 ? (
                        <div
                          className="plus-icon-wrap"
                          onClick={() => handleAddInput(day)}
                        >
                          <img src="./images/icons/avail-add.png" alt="icon" />
                        </div>
                      ) : (
                        <div
                          className="plus-icon-wrap"
                          onClick={() => handleRemoveInput(day, slot.id)}
                        >
                          <img
                            src="./images/icons/avail-delete.png"
                            alt="icon"
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
        <div className="signup-availibty-save-btn">
          <Button
            label="Save"
            isLoading={isLoading}
            onClick={availabiltysetHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default AvailabiltyDrawer;
